
  <div class="preload preload-container">
      <div class="preload-logo">
          <div class="spinner"></div>
      </div>
  </div>
  <!-- /preload -->
  <div id="wrapper">
      <!-- header -->


      <!-- page-title -->
      <div class="tf-page-title style-2">
          <div class="container-full">
              <div class="heading text-center">Inscrivez-Vous</div>
          </div>
      </div>
      <!-- /page-title -->

      <section class="flat-spacing-10">
          <div class="container">
              <div class="form-register-wrap">
                  <div class="flat-title align-items-start gap-0 mb_30 px-0">
                    <h5 class="mb_18">Créer un compte</h5>
                    <p class="text_black-2">
                        Inscrivez-vous pour accéder en avant-première aux ventes, aux nouveautés personnalisées, aux tendances
                        et aux promotions. Pour vous désabonner, cliquez sur le lien de désinscription dans nos e-mails.
                    </p>
                  </div>
                  <div>
                      <form (ngSubmit)="registerUser()" class="" id="register-form" action="#" method="post" accept-charset="utf-8"
                          data-mailchimp="true">
                          <div class="tf-field style-1 mb_15">
                              <input class="tf-field-input tf-input" placeholder=" " type="text" id="property1"
                                  name="prenom"  [(ngModel)]="user.prenom">
                              <label class="tf-field-label fw-4 text_black-2" for="property1">Prénom</label>
                          </div>
                          <div class="tf-field style-1 mb_15">
                              <input class="tf-field-input tf-input" placeholder=" " type="text" id="property2"
                                  name="nom"  [(ngModel)]="user.nom">
                              <label class="tf-field-label fw-4 text_black-2" for="property2">Nom</label>
                          </div>
                          <div class="tf-field style-1 mb_15">
                              <input class="tf-field-input tf-input" placeholder=" " type="email" id="property3"
                                  name="email"  [(ngModel)]="user.email">
                              <label class="tf-field-label fw-4 text_black-2" for="property3">Email *</label>
                          </div>
                          <div class="tf-field style-1 mb_15">
                            <input class="tf-field-input tf-input" placeholder=" " type="text" id="property4"
                                name="telephone"  [(ngModel)]="user.telephone">
                            <label class="tf-field-label fw-4 text_black-2" for="property4">Telephone *</label>
                        </div>
                        <div class="tf-field style-1 mb_15">
                          <input class="tf-field-input tf-input" placeholder=" " type="date" id="property5"
                              name="date_naissance"   [(ngModel)]="user.date_naissance">
                          <label class="tf-field-label fw-4 text_black-2" for="property5">Date de naissance *</label>
                      </div>
                          <div class="tf-field style-1 mb_30">
                            <div class="password-group" style="position: relative;">
                              <input
                                [type]="showPassword ? 'text' : 'password'"
                                id="property6"
                                class="tf-field-input tf-input"
                                placeholder=""
                                [(ngModel)]="user.password"
                                name="password"
                                required
                              />
                              <i
                                class="toggle-password fa"
                                [ngClass]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
                                (click)="togglePasswordVisibility()"
                                style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;"
                              ></i>
                            </div>
                              <label class="tf-field-label fw-4 text_black-2" for="property6">Mot de passe *</label>
                          </div>
                          <div class="tf-field style-1 mb_30">

                            <div class="password-group" style="position: relative;">
                              <input
                                [type]="showConfirmPassword ? 'text' : 'password'"
                                id="property7"
                                class="tf-field-input tf-input"
                                placeholder=""
                                [(ngModel)]="confirmPassword"
                                name="confirmPassword"
                                required
                              />
                              <i
                                class="toggle-password fa"
                                [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"
                                (click)="toggleConfirmPasswordVisibility()"
                                style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;"
                              ></i>
                            </div>
                            <label class="tf-field-label fw-4 text_black-2" for="property7">Confirmer le mot de passe *</label>
                        </div>
                        <p *ngIf="passwordMismatch" style="color: red;">Les mots de passe ne correspondent pas.</p>
                          <div class="mb_20">
                              <button type="submit"
                                  class="tf-btn w-100 radius-3 btn-fill animate-hover-btn justify-content-center">S'inscrire</button>
                          </div>
                          <div class="text-center">
                              <a href="/login" class="tf-btn btn-line"> Vous avez déjà un compte ? Connectez-vous<i
                                      class="icon icon-arrow1-top-left"></i></a>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </section>




  </div>

  <!-- gotop -->
  <button id="goTop">
      <span class="border-progress"></span>
      <span class="icon icon-arrow-up"></span>
  </button>
  <!-- /gotop -->

  <!-- toolbar-bottom -->
  <div class="tf-toolbar-bottom type-1150">
      <div class="toolbar-item">
          <a href="#toolbarShopmb" data-bs-toggle="offcanvas" aria-controls="offcanvasLeft">
              <div class="toolbar-icon">
                  <i class="icon-shop"></i>
              </div>
              <div class="toolbar-label">Shop</div>
          </a>
      </div>

      <div class="toolbar-item">
          <a href="#canvasSearch" data-bs-toggle="offcanvas" aria-controls="offcanvasLeft">
              <div class="toolbar-icon">
                  <i class="icon-search"></i>
              </div>
              <div class="toolbar-label">Search</div>
          </a>
      </div>
      <div class="toolbar-item">
          <a href="#login" data-bs-toggle="modal">
              <div class="toolbar-icon">
                  <i class="icon-account"></i>
              </div>
              <div class="toolbar-label">Account</div>
          </a>
      </div>
      <div class="toolbar-item">
          <a href="wishlist.html">
              <div class="toolbar-icon">
                  <i class="icon-heart"></i>
                  <div class="toolbar-count">0</div>
              </div>
              <div class="toolbar-label">Wishlist</div>
          </a>
      </div>
      <div class="toolbar-item">
          <a href="#shoppingCart" data-bs-toggle="modal">
              <div class="toolbar-icon">
                  <i class="icon-bag"></i>
                  <div class="toolbar-count">1</div>
              </div>
              <div class="toolbar-label">Cart</div>
          </a>
      </div>
  </div>
  <!-- /toolbar-bottom -->


  <div class="modal modalCentered fade form-sign-in modal-part-content" id="register">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <div class="demo-title">Inscrivez-Vous</div>
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="tf-login-form">
                  <form class="">
                      <div class="tf-field style-1">
                          <input class="tf-field-input tf-input" placeholder=" " type="text" name="">
                          <label class="tf-field-label" for="">First name</label>
                      </div>
                      <div class="tf-field style-1">
                          <input class="tf-field-input tf-input" placeholder=" " type="text" name="">
                          <label class="tf-field-label" for="">Last name</label>
                      </div>
                      <div class="tf-field style-1">
                          <input class="tf-field-input tf-input" placeholder=" " type="email" name="">
                          <label class="tf-field-label" for="">Email *</label>
                      </div>
                      <div class="tf-field style-1">
                          <input class="tf-field-input tf-input" placeholder=" " type="password" name="">
                          <label class="tf-field-label" for="">Password *</label>
                      </div>
                      <div class="bottom">
                          <div class="w-100">
                              <a href="register.html"
                                  class="tf-btn btn-fill animate-hover-btn radius-3 w-100 justify-content-center"><span>Register</span></a>
                          </div>
                          <div class="w-100">
                              <a href="#login" data-bs-toggle="modal" class="btn-link fw-6 w-100 link">
                                  Already have an account? Log in here
                                  <i class="icon icon-arrow1-top-left"></i>
                              </a>
                          </div>
                      </div>
                  </form>
              </div>
          </div>
      </div>
  </div>
  <!-- /modal login -->

  <!-- shoppingCart -->

  <!-- /shoppingCart -->

  <!-- modal compare -->
  <div class="offcanvas offcanvas-bottom canvas-compare" id="compare">
      <div class="canvas-wrapper">
          <header class="canvas-header">
              <div class="close-popup">
                  <span class="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
              </div>
          </header>
          <div class="canvas-body">
              <div class="container">
                  <div class="row">
                      <div class="col-12">
                          <div class="tf-compare-list">
                              <div class="tf-compare-head">
                                  <div class="title">Compare Products</div>
                              </div>
                              <div class="tf-compare-offcanvas">
                                  <div class="tf-compare-item">
                                      <div class="position-relative">
                                          <div class="icon">
                                              <i class="icon-close"></i>
                                          </div>
                                          <a href="product-detail.html">
                                              <img class="radius-3" src="assets/images/products/orange-1.jpg" alt="">
                                          </a>
                                      </div>
                                  </div>
                                  <div class="tf-compare-item">
                                      <div class="position-relative">
                                          <div class="icon">
                                              <i class="icon-close"></i>
                                          </div>
                                          <a href="product-detail.html">
                                              <img class="radius-3" src="assets/images/products/pink-1.jpg" alt="">
                                          </a>
                                      </div>
                                  </div>
                              </div>
                              <div class="tf-compare-buttons">
                                  <div class="tf-compare-buttons-wrap">
                                      <a href="compare.html"
                                          class="tf-btn radius-3 btn-fill justify-content-center fw-6 fs-14 flex-grow-1 animate-hover-btn ">Compare</a>
                                      <div class="tf-compapre-button-clear-all link">
                                          Clear All
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- /modal compare -->

  <!-- modal quick_add -->
  <div class="modal fade modalDemo" id="quick_add">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="wrap">
                  <div class="tf-product-info-item">
                      <div class="image">
                          <img src="assets/assets/images/products/orange-1.jpg" alt="">
                      </div>
                      <div class="content">
                          <a href="product-detail.html">Ribbed Tank Top</a>
                          <div class="tf-product-info-price">
                              <!-- <div class="price-on-sale">$8.00</div>
                              <div class="compare-at-price">$10.00</div>
                              <div class="badges-on-sale"><span>20</span>% OFF</div> -->
                              <div class="price">$18.00</div>
                          </div>
                      </div>
                  </div>
                  <div class="tf-product-info-variant-picker mb_15">
                      <div class="variant-picker-item">
                          <div class="variant-picker-label">
                              Color: <span class="fw-6 variant-picker-label-value">Orange</span>
                          </div>
                          <div class="variant-picker-values">
                              <input id="values-orange" type="radio" name="color" checked>
                              <label class="hover-tooltip radius-60" for="values-orange" data-value="Orange">
                                  <span class="btn-checkbox bg-color-orange"></span>
                                  <span class="tooltip">Orange</span>
                              </label>
                              <input id="values-black" type="radio" name="color">
                              <label class=" hover-tooltip radius-60" for="values-black" data-value="Black">
                                  <span class="btn-checkbox bg-color-black"></span>
                                  <span class="tooltip">Black</span>
                              </label>
                              <input id="values-white" type="radio" name="color">
                              <label class="hover-tooltip radius-60" for="values-white" data-value="White">
                                  <span class="btn-checkbox bg-color-white"></span>
                                  <span class="tooltip">White</span>
                              </label>
                          </div>
                      </div>
                      <div class="variant-picker-item">
                          <div class="variant-picker-label">
                              Size: <span class="fw-6 variant-picker-label-value">S</span>
                          </div>
                          <div class="variant-picker-values">
                              <input type="radio" name="size" id="values-s" checked>
                              <label class="style-text" for="values-s" data-value="S">
                                  <p>S</p>
                              </label>
                              <input type="radio" name="size" id="values-m">
                              <label class="style-text" for="values-m" data-value="M">
                                  <p>M</p>
                              </label>
                              <input type="radio" name="size" id="values-l">
                              <label class="style-text" for="values-l" data-value="L">
                                  <p>L</p>
                              </label>
                              <input type="radio" name="size" id="values-xl">
                              <label class="style-text" for="values-xl" data-value="XL">
                                  <p>XL</p>
                              </label>
                          </div>
                      </div>
                  </div>
                  <div class="tf-product-info-quantity mb_15">
                      <div class="quantity-title fw-6">Quantity</div>
                      <div class="wg-quantity">
                          <span class="btn-quantity minus-btn">-</span>
                          <input type="text" name="number" value="1">
                          <span class="btn-quantity plus-btn">+</span>
                      </div>
                  </div>
                  <div class="tf-product-info-buy-button">
                      <form class="">
                          <a href="javascript:void(0);"
                              class="tf-btn btn-fill justify-content-center fw-6 fs-16 flex-grow-1 animate-hover-btn btn-add-to-cart"><span>Add
                                  to cart -&nbsp;</span><span class="tf-qty-price">$18.00</span></a>
                          <div class="tf-product-btn-wishlist btn-icon-action">
                              <i class="icon-heart"></i>
                              <i class="icon-delete"></i>
                          </div>
                          <a href="#compare" data-bs-toggle="offcanvas" aria-controls="offcanvasLeft"
                              class="tf-product-btn-wishlist box-icon bg_white compare btn-icon-action">
                              <span class="icon icon-compare"></span>
                              <span class="icon icon-check"></span>
                          </a>
                          <div class="w-100">
                              <a href="#" class="btns-full">Buy with <img src="assets/images/payments/paypal.png" alt=""></a>
                              <a href="#" class="payment-more-option">More payment options</a>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- /modal quick_add -->

  <!-- modal quick_view -->
  <div class="modal fade modalDemo" id="quick_view">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="wrap">
                  <div class="tf-product-media-wrap">
                      <div dir="ltr" class="swiper tf-single-slide">
                          <div class="swiper-wrapper">
                              <div class="swiper-slide">
                                  <div class="item">
                                      <img src="assets/assets/images/products/orange-1.jpg" alt="">
                                  </div>
                              </div>
                              <div class="swiper-slide">
                                  <div class="item">
                                      <img src="assets/assets/images/products/pink-1.jpg" alt="">
                                  </div>
                              </div>
                          </div>
                          <div class="swiper-button-next button-style-arrow single-slide-prev"></div>
                          <div class="swiper-button-prev button-style-arrow single-slide-next"></div>
                      </div>
                  </div>
                  <div class="tf-product-info-wrap position-relative">
                      <div class="tf-product-info-list">
                          <div class="tf-product-info-title">
                              <h5><a class="link" href="product-detail.html">Ribbed Tank Top</a></h5>
                          </div>
                          <div class="tf-product-info-badges">
                              <div class="badges text-uppercase">Best seller</div>
                              <div class="product-status-content">
                                  <i class="icon-lightning"></i>
                                  <p class="fw-6">Selling fast! 48 people have this in their carts.</p>
                              </div>
                          </div>
                          <div class="tf-product-info-price">
                              <div class="price">$18.00</div>
                          </div>
                          <div class="tf-product-description">
                              <p>Nunc arcu faucibus a et lorem eu a mauris adipiscing conubia ac aptent ligula
                                  facilisis a auctor habitant parturient a a.Interdum fermentum.</p>
                          </div>
                          <div class="tf-product-info-variant-picker">
                              <div class="variant-picker-item">
                                  <div class="variant-picker-label">
                                      Color: <span class="fw-6 variant-picker-label-value">Orange</span>
                                  </div>
                                  <div class="variant-picker-values">
                                      <input id="values-orange-1" type="radio" name="color-1" checked>
                                      <label class="hover-tooltip radius-60" for="values-orange-1"
                                          data-value="Orange">
                                          <span class="btn-checkbox bg-color-orange"></span>
                                          <span class="tooltip">Orange</span>
                                      </label>
                                      <input id="values-black-1" type="radio" name="color-1">
                                      <label class=" hover-tooltip radius-60" for="values-black-1" data-value="Black">
                                          <span class="btn-checkbox bg-color-black"></span>
                                          <span class="tooltip">Black</span>
                                      </label>
                                      <input id="values-white-1" type="radio" name="color-1">
                                      <label class="hover-tooltip radius-60" for="values-white-1" data-value="White">
                                          <span class="btn-checkbox bg-color-white"></span>
                                          <span class="tooltip">White</span>
                                      </label>
                                  </div>
                              </div>
                              <div class="variant-picker-item">
                                  <div class="d-flex justify-content-between align-items-center">
                                      <div class="variant-picker-label">
                                          Size: <span class="fw-6 variant-picker-label-value">S</span>
                                      </div>
                                      <div class="find-size btn-choose-size fw-6">Find your size</div>
                                  </div>
                                  <div class="variant-picker-values">
                                      <input type="radio" name="size-1" id="values-s-1" checked>
                                      <label class="style-text" for="values-s-1" data-value="S">
                                          <p>S</p>
                                      </label>
                                      <input type="radio" name="size-1" id="values-m-1">
                                      <label class="style-text" for="values-m-1" data-value="M">
                                          <p>M</p>
                                      </label>
                                      <input type="radio" name="size-1" id="values-l-1">
                                      <label class="style-text" for="values-l-1" data-value="L">
                                          <p>L</p>
                                      </label>
                                      <input type="radio" name="size-1" id="values-xl-1">
                                      <label class="style-text" for="values-xl-1" data-value="XL">
                                          <p>XL</p>
                                      </label>
                                  </div>
                              </div>
                          </div>
                          <div class="tf-product-info-quantity">
                              <div class="quantity-title fw-6">Quantity</div>
                              <div class="wg-quantity">
                                  <span class="btn-quantity minus-btn">-</span>
                                  <input type="text" name="number" value="1">
                                  <span class="btn-quantity plus-btn">+</span>
                              </div>
                          </div>
                          <div class="tf-product-info-buy-button">
                              <form class="">
                                  <a href="javascript:void(0);"
                                      class="tf-btn btn-fill justify-content-center fw-6 fs-16 flex-grow-1 animate-hover-btn btn-add-to-cart"><span>Add
                                          to cart -&nbsp;</span><span class="tf-qty-price">$8.00</span></a>
                                  <a href="javascript:void(0);"
                                      class="tf-product-btn-wishlist hover-tooltip box-icon bg_white wishlist btn-icon-action">
                                      <span class="icon icon-heart"></span>
                                      <span class="tooltip">Add to Wishlist</span>
                                      <span class="icon icon-delete"></span>
                                  </a>
                                  <a href="#compare" data-bs-toggle="offcanvas" aria-controls="offcanvasLeft"
                                      class="tf-product-btn-wishlist hover-tooltip box-icon bg_white compare btn-icon-action">
                                      <span class="icon icon-compare"></span>
                                      <span class="tooltip">Add to Compare</span>
                                      <span class="icon icon-check"></span>
                                  </a>
                                  <div class="w-100">
                                      <a href="#" class="btns-full">Buy with <img src="assets/images/payments/paypal.png"
                                              alt=""></a>
                                      <a href="#" class="payment-more-option">More payment options</a>
                                  </div>
                              </form>
                          </div>
                          <div>
                              <a href="product-detail.html" class="tf-btn fw-6 btn-line">View full details<i
                                      class="icon icon-arrow1-top-left"></i></a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- /modal quick_view -->

  <!-- modal find_size -->
  <div class="modal fade modalDemo tf-product-modal" id="find_size">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <div class="demo-title">Size chart</div>
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="tf-rte">
                  <div class="tf-table-res-df">
                      <h6>Size guide</h6>
                      <table class="tf-sizeguide-table">
                          <thead>
                              <tr>
                                  <th>Size</th>
                                  <th>US</th>
                                  <th>Bust</th>
                                  <th>Waist</th>
                                  <th>Low Hip</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr>
                                  <td>XS</td>
                                  <td>2</td>
                                  <td>32</td>
                                  <td>24 - 25</td>
                                  <td>33 - 34</td>
                              </tr>
                              <tr>
                                  <td>S</td>
                                  <td>4</td>
                                  <td>34 - 35</td>
                                  <td>26 - 27</td>
                                  <td>35 - 26</td>
                              </tr>
                              <tr>
                                  <td>M</td>
                                  <td>6</td>
                                  <td>36 - 37</td>
                                  <td>28 - 29</td>
                                  <td>38 - 40</td>
                              </tr>
                              <tr>
                                  <td>L</td>
                                  <td>8</td>
                                  <td>38 - 29</td>
                                  <td>30 - 31</td>
                                  <td>42 - 44</td>
                              </tr>
                              <tr>
                                  <td>XL</td>
                                  <td>10</td>
                                  <td>40 - 41</td>
                                  <td>32 - 33</td>
                                  <td>45 - 47</td>
                              </tr>
                              <tr>
                                  <td>XXL</td>
                                  <td>12</td>
                                  <td>42 - 43</td>
                                  <td>34 - 35</td>
                                  <td>48 - 50</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
                  <div class="tf-page-size-chart-content">
                      <div>
                          <h6>Measuring Tips</h6>
                          <div class="title">Bust</div>
                          <p>Measure around the fullest part of your bust.</p>
                          <div class="title">Waist</div>
                          <p>Measure around the narrowest part of your torso.</p>
                          <div class="title">Low Hip</div>
                          <p class="mb-0">With your feet together measure around the fullest part of your hips/rear.
                          </p>
                      </div>
                      <div>
                          <img class="sizechart lazyload" data-src="assets/images/shop/products/size_chart2.jpg"
                              src="assets/images/shop/products/size_chart2.jpg" alt="">
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- /modal find_size -->

